export const styles = {
  container: {
    padding: "40px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    background: "#FAFAFA",
    marginTop: "20px",
    borderRadius: "10px",
  },
  imageContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  text: {
    marginTop: "20px",
    color: "events.lightBlack",
  },
  listTitle: {
    marginTop: "20px",
    fontWeight: 600,
    color: "events.lightBlack",
  },
  list: {
    marginTop: "4px",
    paddingLeft: "20px",
    "& li": {
      color: "events.lightBlack",
    },
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
};
